import { call, fork, put, take } from 'redux-saga/effects';
import { api } from 'rp-auth';
import { showLightbox } from '../actions/lightbox';
import {
  subscriptionUpgradeSucceeded,
  subscriptionUpgradeFailed,
  SUBSCRIPTION_UPGRADE_REQUESTED,
} from '../actions/subscriptions';

export function* upgradeSubscription({ payload }) {
  try {
    const userSubscription = yield call(api.upgradeSubscription, payload);
    yield put(subscriptionUpgradeSucceeded(userSubscription));
    yield put(showLightbox());
  } catch ({ response: { data } }) {
    yield put(subscriptionUpgradeFailed(data));
  }
}

export function* watchUpgradeSubscription() {
  while (true) {
    const action = yield take(SUBSCRIPTION_UPGRADE_REQUESTED);
    yield fork(upgradeSubscription, action);
  }
}

